<form class="quoteForm" #quoteForm="ngForm">
  @if (quote(); as quote) {
    <div class="toolbar">
      <span>
        <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="backToQuoteMaster()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <span class="buttonLabel">Back To Search</span>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
      <span class="buttonContainer">
        @if (showProjectDefaultsButton()) {
          <button class="toolbarButton"
            matButton="text" [matMenuTriggerFor]="projectActionsMenu">
            <span>
              <span class="buttonLabel">Project Defaults</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #projectActionsMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="openProjectDefaultsScreen()">
            <mat-icon class="size-12">dashboard</mat-icon>
            <span class="buttonLabel">Project Level Information</span>
          </button>
        </mat-menu>
        @if (!isNew() && quote.updateAllowed) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()"
            [matMenuTriggerFor]="pricingMenu">
            <span>
              <span class="buttonLabel">Pricing</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #pricingMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item [disabled]="quoteForm.invalid" (click)="multiplier()">
            <mat-icon class="size-12">keyboard</mat-icon>
            <span class="buttonLabel">Multiplier</span>
          </button>
          @if (showFpaManagementButton()) {
            <button class="menuButton" mat-menu-item (click)="fpaManagement()">
              <mat-icon class="size-12">attach_money</mat-icon>
              <span class="buttonLabel">Request FPA</span>
            </button>
          }
          @if (showFpaCancelButton()) {
            <button class="menuButton" mat-menu-item (click)="cancelFpaReview()">
              <mat-icon class="size-12">cancel</mat-icon>
              <span class="buttonLabel">Cancel FPA Review</span>
            </button>
          }
          @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
            <button class="menuButton"
              mat-menu-item (click)="viewEntityBreaks()">
              <mat-icon class="size-12">subject</mat-icon>
              <span class="buttonLabel">Quote Breaks</span>
            </button>
          }
          @if (canUpdateExtendedWarranty()) {
            <button class="menuButton" mat-menu-item
              (click)="showExtendedWarrantyDialog()">
              <mat-icon class="size-12">verified</mat-icon>
              <span class="buttonLabel">Extended Warranty</span>
            </button>
          }
          @if (isInternalOrRsm()) {
            <button class="menuButton" mat-menu-item (click)="openCostReport()">
              <mat-icon class="size-12">request_quote</mat-icon>
              <span class="buttonLabel">Cost Report</span>
            </button>
            <button class="menuButton" mat-menu-item (click)="openAutoCostReport()">
              <mat-icon class="size-12">auto_graph</mat-icon>
              <span class="buttonLabel">Auto-Cost Report</span>
            </button>
          }
        </mat-menu>
        @if (!isNew()) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" [matMenuTriggerFor]="actionsMenu">
            <span>
              <span class="buttonLabel">Actions</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #actionsMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="copy()">
            <mat-icon class="size-12">add_to_photos</mat-icon>
            <span class="buttonLabel">Copy</span>
          </button>
          @if (quote.updateAllowed) {
            <button class="menuButton" mat-menu-item (click)="cancel()">
              <mat-icon class="size-12">do_not_disturb</mat-icon>
              <span class="buttonLabel">Cancel</span>
            </button>
          }
          @if (canApprove()) {
            <button class="menuButton" mat-menu-item [disabled]="hasOpenBypassTask()" (click)="approveQuote()">
              <mat-icon class="size-12">assignment_turned_in</mat-icon>
              <span class="buttonLabel">Approve</span>
            </button>
          }
          @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
            <button class="menuButton"
              mat-menu-item (click)="fixPermissions()">
              <mat-icon class="size-12">lock_open</mat-icon>
              <span class="buttonLabel">Fix Permissions</span>
            </button>
          }
          @if (creditDocumentsNeeded()) {
            <button class="menuButton" mat-menu-item
              (click)="startCreditDocumentWorkflow()">
              <span>
                <mat-icon class="size-12">play_arrow</mat-icon>
                <span class="buttonLabel">Start Credit Process</span>
              </span>
            </button>
          }
          @if (quote.updateAllowed) {
            <button class="menuButton" mat-menu-item (click)="updateEntityComplexity()">
              <mat-icon class="size-12">refresh</mat-icon>
              <span class="buttonLabel">Refresh Complexity</span>
            </button>
          }
          @if (userHasRole('IECIT') || userHasRole('IECQEWLAdmin')) {
            <button class="menuButton" mat-menu-item
              (click)="openQewlDialog()">
              <mat-icon class="size-12">layers</mat-icon>
              <span class="buttonLabel">QEWL</span>
            </button>
          }
          @if (showAssignNewOpportunityOption() && isInternalOrRsm()) {
            <button class="menuButton" mat-menu-item
              (click)="assignNewOpportunity()">
              <mat-icon class="size-12">autorenew</mat-icon>
              <span class="buttonLabel">Assign New Opportunity</span>
            </button>
          }
          @if (showUnrestrictedEditOption()) {
            <button class="menuButton" mat-menu-item (click)="showUnrestrictedChangesDialog()">
              <mat-icon class="size-12">edit</mat-icon>
              <span class="buttonLabel">Update Approved Quote</span>
            </button>
          }

        </mat-menu>
        @if (!isNew() && quote.updateAllowed) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" [matMenuTriggerFor]="sfrMenu">
            <span>
              <span class="buttonLabel">SFR Actions</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #sfrMenu="matMenu" [overlapTrigger]="false">
          <button class="menuButton" mat-menu-item (click)="sfrManagement()">
            <mat-icon class="size-12">local_grocery_store</mat-icon>
            <span class="buttonLabel">SFR Management</span>
          </button>
          @if (canSubmitSfrs()) {
            <button class="menuButton" mat-menu-item (click)="submitSfr()">
              <mat-icon class="size-12">event_available</mat-icon>
              <span class="buttonLabel">Submit SFR</span>
            </button>
          }
          @if (canCancelSfrs()) {
            <button class="menuButton" mat-menu-item (click)="cancelSfr()">
              <mat-icon class="size-12">not_interested</mat-icon>
              <span class="buttonLabel">Cancel Review</span>
            </button>
          }
        </mat-menu>
        @if (!isNew()) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="viewDocuments()">
            <span>
              <mat-icon class="size-16">content_copy</mat-icon>
              <span class="buttonLabel">Docs</span>
            </span>
          </button>
        }
        @if (!isNew()) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" [matMenuTriggerFor]="viewMenu">
            <span>
              <span class="buttonLabel">View</span>
              <mat-icon class="size-16">arrow_drop_down</mat-icon>
            </span>
          </button>
        }
        <mat-menu #viewMenu="matMenu" [overlapTrigger]="false">
          @if (quote.opportunityId && quote.opportunityId.length > 0 && userCanViewOpportunity()) {
            <a
              class="menuButton" mat-menu-item
              [routerLink]="['/opportunities', quote.opportunityId, quote.opportunityRevision]" target="_blank">
              <mat-icon class="size-12">attach_file</mat-icon>
              <span class="buttonLabel">Opportunity</span>
            </a>
          }
          @if (associatedOrders() && associatedOrders().length > 0) {
            <button class="menuButton" mat-menu-item
              [matMenuTriggerFor]="associatedOrdersMenu">
              <mat-icon class="size-12">attach_file</mat-icon>
              <span class="buttonLabel">Order</span>
            </button>
          }
          <button class="menuButton" mat-menu-item (click)="showEntityHistoryDialog()">
            <mat-icon class="size-12">history</mat-icon>
            <span class="buttonLabel">History</span>
          </button>
        </mat-menu>
        <mat-menu #associatedOrdersMenu="matMenu">
          @for (order of associatedOrders(); track order) {
            <button class="menuButton" mat-menu-item
              (click)="viewOrder(order)">
              <span class="buttonLabel">{{ order.entityId }};{{ order.entityRevision }}</span>
            </button>
          }
        </mat-menu>
        @if (quote.updateAllowed) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy() || !quoteForm.valid || quote.frozen" (click)="save()">
            <span>
              <mat-icon class="size-16">save</mat-icon>
              <span class="buttonLabel">Save</span>
            </span>
          </button>
        }
        @if (!isNew() && quote.updateAllowed && (!isPaperPilotLeadTime(quote.leadTimeCode) || isPaperPilotUser())) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy() || hasOpenBypassTask()" (click)="placeOrder()">
            <span>
              <mat-icon class="size-16">done</mat-icon>
              <span class="buttonLabel">{{ isPaperPilotLeadTime(quote.leadTimeCode) ? 'Send to EWL' : 'Place Order' }}</span>
            </span>
          </button>
        }
      </span>
    </div>
  }
  @if (errorMessage()) {
    <div class="errorMessage">
      <pre>{{ errorMessage() }}</pre>
    </div>
  }
  @if (saveMessages() && saveMessages().length > 0) {
    <div class="saveMessage">
      @for (message of saveMessages(); track message) {
        <div>
          {{ message }}
        </div>
      }
    </div>
  }
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <span class="busyLabel">{{ waitMessage() }}</span>
      </div>
    </div>
  }
  @if (quote(); as quote) {
    <div class="quoteDetail">
      <div class="thirdColumn">
        <div class="infoPanel">
          <div class="panelHeader">
            <span>Quote Information</span>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              @if (quote.id && quote.id.entityId && quote.id.entityId.length > 0) {
                <tr>
                  <td class="rightAligned labelColumn"><span>QuoteID:</span></td>
                  <td class="dataColumn"><span>{{ quote.id.entityId }};{{ quote.id.entityRevision }}</span></td>
                </tr>
              }
              <tr>
                <td class="rightAligned labelColumn"><label for="projectNameInput">Project Name:</label>
              </td>
              <td class="dataColumn">
                <input id="projectNameInput" name="projectNameInput" class="inputField standardTextBox"
                  maxlength="30" [ngClass]="{'inputError': projectNameInput.invalid}" required
                  [(ngModel)]="quote.projectName" #projectNameInput="ngModel"/>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label for="customerSelection">Customer:</label></td>
              <td class="dataColumn">
                <select id="customerSelection" name="customerSelection" class="inputField"
                  [(ngModel)]="quote.customerId">
                  @for (customer of customers(); track customer) {
                    <option [value]="customer.code">
                      {{ customer.description }}
                    </option>
                  }
                </select>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><span>Rep Office:</span></td>
              <td class="dataColumn">
                @if (showRepOfficeDropDown()) {
                  <div
                    [ngClass]="{'selectionError': repOfficeSelection.invalid}">
                    <select id="repOfficeSelection" name="repOfficeSelection" class="inputField"
                      required [(ngModel)]="quote.repOfficeId"
                      (change)="loadSellingOrganizationSelections()" #repOfficeSelection="ngModel">
                      <option value="undefined" disabled>Please Select</option>
                      @for (rep of repOffices(); track rep) {
                        <option [value]="rep.code">{{ rep.description }}
                        </option>
                      }
                    </select>
                  </div>
                }
                @if (!showRepOfficeDropDown()) {
                  <span>{{ sellingOrgDescription() }}</span>
                }
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><span>Release Type:</span></td>
              <td class="dataColumn">
                <div [ngClass]="{'selectionError': releaseTypeSelection.invalid}">
                  <select name="releaseTypeSelection" class="inputField" required
                    [(ngModel)]="quote.releaseTypeId" #releaseTypeSelection="ngModel">
                    <option value="undefined" disabled>Please Select</option>
                    @for (releaseType of releaseTypes(); track releaseType) {
                      <option [value]="releaseType.code">
                        {{ releaseType.description }}
                      </option>
                    }
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><span>Associated Quote:</span></td>
              <td class="dataColumn"><span>{{ quote.associatedQuoteId }}</span></td>
            </tr>
            @if (userHasRole('IECCustomerService') || userHasRole('IECIT') || userHasRole('IECCredAnalyst') || userHasRole('IECApplicationEngineer') || userHasRole('IECRSM') ) {
              <tr
                >
                <td colspan="2">
                  <textarea name="internalNotesInput" rows="3" class="noresize fullWidth"
                  [(ngModel)]="quote.internalNotes" placeholder="Internal Notes"></textarea>
                </td>
              </tr>
            }
          </table>
        </div>
      </div>
      <div class="infoPanel">
        <div class="panelHeader">
          <span>Processing and Contacts</span>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr>
              <td class="rightAligned labelColumn"><span>Est Sch Date:</span></td>
              <td class="dataColumn">
                <span>{{ quote.estimatedScheduleDate | date:'MM/dd/yyyy':'UTC' }}</span>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><span>FOB:</span></td>
              <td class="dataColumn">
                @if (userHasRole('IECIT') || userHasRole('IECCredAnalyst')) {
                  <div
                    [ngClass]="{'selectionError': fobCodeInput.invalid}">
                    <select name="fobCodeInput" class="inputField" required [(ngModel)]="quote.fobCode"
                      #fobCodeInput="ngModel">
                      <option value="undefined" disabled>Please Select</option>
                      @for (fob of fobs(); track fob) {
                        <option [value]="fob.code">{{ fob.description }}</option>
                      }
                    </select>
                  </div>
                }
                @if (!userHasRole('IECIT') && !userHasRole('IECCredAnalyst')) {
                  <span
                  >{{ quote.fobCode }}</span>
                }
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><span>Order Info:</span></td>
              <td class="dataColumn">
                @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
                  <div>
                    <input name="orderInfoInput" class="inputField standardTextBox" maxlength="10"
                      [(ngModel)]="quote.orderInfo" />
                  </div>
                }
                @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService')) {
                  <div>
                    <span>{{ quote.orderInfo }}</span>
                  </div>
                }
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><span>Payment Terms:</span></td>
              <td class="dataColumn">
                @if (userHasRole('IECIT') || userHasRole('IECCredAnalyst')) {
                  <div
                    [ngClass]="{'selectionError': paymentTermsInput.invalid}">
                    <select name="paymentTermsInput" class="inputField" required
                      [(ngModel)]="quote.paymentTermsCode" #paymentTermsInput="ngModel">
                      <option value="undefined" disabled>Please Select</option>
                      @for (paymentTerm of paymentTerms(); track paymentTerm) {
                        <option [value]="paymentTerm.code">
                          {{ paymentTerm.description }}
                        </option>
                      }
                    </select>
                  </div>
                }
                @if (!userHasRole('IECIT') && !userHasRole('IECCredAnalyst')) {
                  <span
                  >{{ quote.paymentTermsCode }}</span>
                }
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn">
                <span>Expiration Date:</span>
              </td>
              <td class="dataColumn">
                @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
                  <div>
                    <input [matDatepicker]="expirationDatePicker" name="expirationDateInput"
                      [value]="formatDisplayDate(quote.expirationDate)"
                      (dateChange)="setExpirationDate($event.value)"/>
                    <mat-datepicker-toggle [for]="expirationDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker id="expirationDatePicker" #expirationDatePicker></mat-datepicker>
                  </div>
                }
                @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService')) {
                  <span
                    >{{
                    quote.expirationDate
                    | date:'MM/dd/yyyy':'UTC'
                  }}</span>
                }
              </td>
            </tr>
            <tr>
              <td class="rightAligned">
                <span class="repSelection" (click)="showSalesRep()">
                  Sales Rep:
                </span>
              </td>
              <td class="dataColumn">
                <div [ngClass]="{'selectionError': salesRepIdInput.invalid}">
                  <select id="salesRepIdInput" name="salesRepIdInput" class="inputField" required
                    [(ngModel)]="quote.salesRepId" #salesRepIdInput="ngModel">
                    <option value="undefined" disabled>Please Select</option>
                    @for (salesRep of salesReps(); track salesRep) {
                      <option [value]="salesRep.code">
                        {{ salesRep.description }}
                      </option>
                    }
                  </select>
                </div>
              </td>
            </tr>
            @if (quote.totalQuoteAmount > 50000) {
              <tr>
                <td class="rightAligned labelColumn">
                  <label for="outsideSalesRepIdInput">Outside Sales Rep:</label>
                </td>
                <td class="dataColumn">
                  <div [ngClass]="{'selectionError': outsideSalesRepIdInput.invalid}">
                    <select id="outsideSalesRepIdInput" name="outsideSalesRepIdInput" class="inputField"
                      [required]="quote.totalQuoteAmount > 50000"
                      [(ngModel)]="quote.outsideSalesRepId" #outsideSalesRepIdInput="ngModel">
                      <option value="undefined" disabled>Please Select</option>
                      @for (salesRep of outsideSalesReps(); track salesRep) {
                        <option [value]="salesRep.code">
                          {{ salesRep.description }}
                        </option>
                      }
                    </select>
                  </div>
                </td>
              </tr>
            }
            <tr>
              <td class="rightAligned labelColumn">
                <span>SFR Price Date:</span>
              </td>
              <td class="dataColumn">
                @if (userHasRole('IECIT')) {
                  <div>
                    <input [matDatepicker]="sfrPriceDatePicker" name="sfrPriceDateInput"
                      [value]="formatDisplayDate(quote.sfrPriceBasisDate)"
                      (dateChange)="setSfrPriceDate($event.value)"/>
                    <mat-datepicker-toggle [for]="sfrPriceDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker id="sfrPriceDatePicker" #sfrPriceDatePicker></mat-datepicker>
                  </div>
                }
                @if (!userHasRole('IECIT')) {
                  <span>{{
                    quote.sfrPriceBasisDate |
                    date:'MM/dd/yyyy':'UTC'
                  }}</span>
                }
              </td>
            </tr>
            <tr>
              <td class="rightAligned">
                <span class="repSelection" (click)="showIecContact()">
                  IEC Contact:
                </span>
              </td>
              <td class="dataColumn">
                @if (userHasRole('IECCustomerService') || userHasRole('IECIT') || userHasRole('IECCredAnalyst') || userHasRole('IECApplicationEngineer') || userHasRole('IECRSM')) {
                  <div
                    [ngClass]="{'selectionError': iecContactIdInput.invalid}">
                    <select name="iecContactIdInput" class="inputField" required
                      [(ngModel)]="quote.iecContactId" #iecContactIdInput="ngModel">
                      <option value="null" disabled>Please Select</option>
                      @for (iecContact of iecContacts(); track iecContact) {
                        <option [value]="iecContact.code">
                          {{ iecContact.description }}
                        </option>
                      }
                    </select>
                  </div>
                }
                @if (!userHasRole('IECCustomerService') && !userHasRole('IECIT') && !userHasRole('IECCredAnalyst') && !userHasRole('IECApplicationEngineer') && !userHasRole('IECRSM')) {
                  <span
                  >{{ quote.iecContactDescription }}</span>
                }
              </td>
            </tr>
            @if (quote.skyportServicePresent) {
              <tr>
                <td [ngClass]="{'skyportError': skyportContactMissing()}" class="rightAligned">
                  <span class="repSelection" (click)="selectSkyportContact()">
                    Skyport Contact
                  </span>
                </td>
              </tr>
            }
            <tr>
              <td class="rightAligned labelColumn"><span>Last Process Date:</span></td>
              <td class="dataColumn"><span>{{ quote.lastProcessDate | date:'MM/dd/yyyy':'UTC' }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2"><span>Created: {{ createdBy() }} -
            {{ quote.createTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</span></td>
          </tr>
          <tr>
            <td colspan="2"><span>Updated: {{ updatedBy() }} -
            {{ quote.updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC' }}</span></td>
          </tr>
          @if (hasMissingRiserData()) {
            <tr>
              <td colspan="2">
                <div class="riser-error">
                  This quote has missing or invalid riser data.&nbsp;&nbsp;Please upload a valid riser chart
                </div>
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  </div>
  <div class="thirdColumn">
    <div class="infoPanel">
      <div class="panelHeader">
        <span>Pricing Controls</span>
      </div>
      <div class="panelBody">
        <table class="layoutTable">
          <tr>
            <td>
              @if (quote.leadTimeCode === 'WAR') {
                <span class="warrantyTextSelection"
                  (click)="showWarrantyText()">
                  Warranty Text
                </span>
              }
            </td>
            <td class="rightAligned labelColumn"><span>Lead Time:</span></td>
            <td class="dataColumn">
              @if (quote.leadTimeCode !== 'WAR' && quote.leadTimeCode !== 'SLC' && !(isPaperPilotLeadTime(quote.leadTimeCode) && !isPaperPilotUser())) {
                <div>
                  <select name="leadTimeCodeInput" class="inputField" (change)="refreshIecContact()"
                    [(ngModel)]="quote.leadTimeCode">
                    @for (leadTime of leadTimes(); track leadTime) {
                      <option [value]="leadTime.code">
                        {{ leadTime.description }}
                      </option>
                    }
                  </select>
                </div>
              }
              @if (quote.leadTimeCode === 'WAR') {
                <span>Warranty</span>
              }
              @if (quote.leadTimeCode === 'SLC') {
                <span>Sales Concession</span>
              }
              @if (isPaperPilotLeadTime(quote.leadTimeCode) && !isPaperPilotUser()) {
                <span>Paper Pilot</span>
              }
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="rightAligned labelColumn"><span>Sales Channel:</span></td>
            <td class="dataColumn">
              <select name="salesChannelCodeInput" class="inputField"
                [(ngModel)]="quote.salesChannelCode">
                @for (salesChannel of salesChannels(); track salesChannel) {
                  <option [value]="salesChannel.code">
                    {{ salesChannel.description }}
                  </option>
                }
              </select>
            </td>
          </tr>
          @if (showExpediteParts()) {
            <tr>
              <td></td>
              <td class="rightAligned labelColumn"></td>
              <td class="dataColumn">
                <input name="expeditePartsInput" id="expeditePartsInput" class="checkboxInput"
                  type="checkbox" [(ngModel)]="quote.expedite"/>
                <label for="expeditePartsInput">Expedite Parts</label>
              </td>
            </tr>
          }
          @if (isBypassUser() || quote.appEngineerSnBypass) {
            <tr>
              <td></td>
              <td class="rightAligned labelColumn"></td>
              <td class="dataColumn">
                <span [title]="getSnBypassDisabledTooltip()">
                  <input name="serialNumberBypassInput" id="serialNumberBypassInput" class="checkboxInput"
                    type="checkbox"
                    [disabled]="!isBypassUser() || isNew() || !quote.updateAllowed || (quote.appEngineerSnBypass && hasLinesRequiringSerialNumber())"
                    [(ngModel)]="quote.appEngineerSnBypass" (ngModelChange)="onSnBypassChange($event)"/>
                  <label for="serialNumberBypassInput">Serial Number Bypass</label>
                </span>
              </td>
            </tr>
          }
          @if (userHasRole('IECIT') || userHasRole('IECCustomerService') || userHasRole('IECCredAnalyst')) {
            <tr
              >
              <td></td>
              <td class="rightAligned labelColumn"><span>Use Type:</span></td>
              <td class="dataColumn">
                <select name="useTypeCodeInput" class="inputField" [(ngModel)]="quote.useTypeCode">
                  <option value="null" disabled>Please Select</option>
                  @for (useType of useTypes(); track useType) {
                    <option [value]="useType.code">
                      {{ useType.description }}
                    </option>
                  }
                </select>
              </td>
            </tr>
          }
          <tr>
            <td></td>
            <td class="rightAligned labelColumn"><span>Price Basis Date:</span></td>
            <td class="dataColumn">
              @if (userHasRole('IECIT')) {
                <div>
                  <input [matDatepicker]="priceBasisDatePicker" name="priceBasisDateInput"
                    [value]="formatDisplayDate(quote.priceBasisDate)"
                    (dateChange)="setPriceBasisDate($event.value)"/>
                  <mat-datepicker-toggle [for]="priceBasisDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker id="priceBasisDatePicker" #priceBasisDatePicker></mat-datepicker>
                </div>
              }
              @if (!userHasRole('IECIT')) {
                <span>{{
                  quote.priceBasisDate |
                  date:'MM/dd/yyyy':'UTC'
                }}</span>
              }
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="rightAligned labelColumn"><span>S&amp;H Charge Type:</span></td>
            <td class="dataColumn">
              @if (userHasRole('IECIT') || userHasRole('IECCustomerService') || userHasRole('IECCredAnalyst')) {
                <div
                  >
                  <select name="shipChargeTypeInput" class="inputField"
                    [(ngModel)]="quote.shipAndHandChargeType">
                    <option value="null" disabled>Please Select</option>
                    @for (sAndHChargeType of sAndHChargeTypes(); track sAndHChargeType) {
                      <option [value]="sAndHChargeType.code"
                        >
                        {{ sAndHChargeType.description }}
                      </option>
                    }
                  </select>
                </div>
              }
              @if (!userHasRole('IECIT') && !userHasRole('IECCustomerService') && !userHasRole('IECCredAnalyst')) {
                <span
                >{{ shippingHandlingDescription() }}</span>
              }
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="infoPanel">
      <div class="panelHeader">
        <span>Shipping Information</span>
      </div>
      <div class="panelBody">
        <table class="layoutTable">
          <tr>
            <td class="rightAligned labelColumn"><span>Ship To:</span></td>
            <td class="dataColumn">
              <span class="addressSelection" (click)="selectAddress()">
                {{ quote.overrideShipToAddressLine1 || 'Select' }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Ship Via:</span></td>
            <td class="dataColumn">
              <select name="shipViaCodeInput" class="inputField" [(ngModel)]="quote.shipViaCode">
                <option value="null" disabled>Please Select</option>
                @for (shipVia of shipVias(); track shipVia) {
                  <option [value]="shipVia.code">
                    {{ shipVia.description }}
                  </option>
                }
              </select>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"></td>
            <td class="dataColumn">
              <input name="partialAllowedInput" id="partialAllowedInput" class="checkboxInput"
                type="checkbox" [(ngModel)]="quote.partialShipmentAllowed"/>
              <label for="partialAllowedInput">Partial Shipment Allowed</label>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Requested Ship Date:</span></td>
            <td class="dataColumn">
              <input [matDatepicker]="requestedShipDatePicker" name="requestedShipDateInput"
                [value]="formatDisplayDate(quote.requestedShipDate)"
                (dateChange)="setRequestedShipDate($event.value)"/>
              <mat-datepicker-toggle [for]="requestedShipDatePicker"></mat-datepicker-toggle>
              <mat-datepicker id="requestedShipDatePicker" #requestedShipDatePicker></mat-datepicker>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"></td>
            <td class="dataColumn">
              <input name="acceptEarlyInput" id="acceptEarlyInput" class="checkboxInput"
                type="checkbox" [(ngModel)]="quote.acceptEarlyDelivery"/>
              <label for="acceptEarlyInput">Accept Early Delivery</label>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Advance Notice Hours:</span></td>
            <td class="dataColumn">
              <input name="advanceNoticeHoursInput" class="inputField standardTextBox" maxlength="28"
                [(ngModel)]="quote.advanceNoticeHours" />
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Rep PO#:</span></td>
            <td class="dataColumn">
              <input name="repPoInput" class="inputField standardTextBox" maxlength="15"
                [(ngModel)]="quote.repPo" />
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Rep Ref#:</span></td>
            <td class="dataColumn">
              <input name="repRefInput" class="inputField standardTextBox" maxlength="15"
                [(ngModel)]="quote.repRef" />
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Primary Contact:</span></td>
            <td class="dataColumn">
              <span [hidden]="quote.deliveryContactName || quote.deliveryPhone"
                class="addressSelection" (click)="enterContact(true)">
                Enter Contact
              </span>
              <span [hidden]="!(quote.deliveryContactName || quote.deliveryPhone)"
                class="addressSelection" (click)="enterContact(true)">
                {{ quote.deliveryContactName + "; " + quote.deliveryPhone }}
              </span>
            </td>
          </tr>
          <tr [hidden]="!(quote.deliveryContactName && quote.deliveryPhone)">
            <td class="rightAligned labelColumn"><span>Secondary Contact:</span></td>
            <td class="dataColumn">
              <span [hidden]="quote.deliveryContactName2 || quote.deliveryPhone2"
                class="addressSelection" (click)="enterContact(false)">
                Enter Contact
              </span>
              <span [hidden]="!(quote.deliveryContactName2|| quote.deliveryPhone2)"
                class="addressSelection" (click)="enterContact(false)">
                {{ quote.deliveryContactName2 + "; " + quote.deliveryPhone2 }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Delivery Country:</span></td>
            <td class="dataColumn">
              <select name="deliveryCountryInput" class="inputField"
                [(ngModel)]="quote.deliveryCountryCode">
                <option value="null" disabled>Please Select</option>
                @for (country of deliveryCountries(); track country) {
                  <option [value]="country.code">
                    {{ country.description }}
                  </option>
                }
              </select>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Mark Cartons:</span></td>
            <td class="dataColumn">
              <input name="markCartonsInput" class="inputField standardTextBox" maxlength="30"
                [(ngModel)]="quote.markCartons" />
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <textarea name="externalNotesInput" rows="3" class="noresize fullWidth"
                [(ngModel)]="quote.externalNotes" placeholder="External Notes"></textarea>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div class="thirdColumn">
    <div class="infoPanel">
      <div class="panelHeader">
        <span>Marketing</span>
      </div>
      <div class="panelBody">
        <table class="layoutTable">
          <tr>
            <td class="rightAligned labelColumn"><span>Market Segment:</span></td>
            <td class="dataColumn">
              <div [ngClass]="{'inputError': marketSegmentMissing()}">
                <select name="marketSegmentInput" class="marketingInput"
                  [(ngModel)]="quote.marketSegmentCode">
                  @for (segment of marketSegments(); track segment) {
                    <option [value]="segment.code">
                      {{ segment.description }}
                    </option>
                  }
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Project Type:</span></td>
            <td class="dataColumn">
              <div [ngClass]="{'inputError': projectTypeMissing()}">
                <select name="projectTypeInput" class="marketingInput"
                  [(ngModel)]="quote.projectTypeCode">
                  @for (projectType of projectTypes(); track projectType) {
                    <option [value]="projectType.code">
                      {{ projectType.description }}
                    </option>
                  }
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Spec Type:</span></td>
            <td class="dataColumn">
              <div [ngClass]="{'inputError': specTypeMissing()}">
                <select name="specTypeInput" class="marketingInput" [(ngModel)]="quote.specTypeCode">
                  @for (specType of specTypes(); track specType) {
                    <option [value]="specType.code">
                      {{ specType.description }}
                    </option>
                  }
                </select>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="infoPanel">
      <div class="panelHeader">
        <span>Quote Totals</span>
      </div>
      <div class="panelBody">
        <table class="layoutTable">
          <tr>
            <td class="rightAligned labelColumn"><span>Total List:</span></td>
            <td class="dataColumn"><span>{{ quote.totalList | currency:'USD' }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Net Amount:</span></td>
            <td class="dataColumn"><span>{{ quote.netAmount | currency:'USD' }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Special Charges:</span></td>
            <td class="dataColumn"><span>{{ (quote.specialCharges - quote.shippingHandlingChargeAmount - quote.partShippingHandlingChargeAmount) | currency:'USD' }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Shipping and Handling:</span></td>
            <td class="dataColumn"><span>{{ quote.shippingHandlingChargeAmount | currency:'USD' }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><label>Part Shipping and Handling:</label></td>
            <td class="dataColumn"><label>{{ quote.partShippingHandlingChargeAmount | currency:'USD' }}</label></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Total Quote Amount:</span></td>
            <td class="dataColumn"><span>{{ quote.totalQuoteAmount | currency:'USD' }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Multiplier:</span></td>
            <td class="dataColumn"><span>{{ quote.multiplier | number:'1.4-7' }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Unit Quantity:</span></td>
            <td class="dataColumn"><span>{{ quote.unitQuantity }}</span></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="infoPanel">
      <div class="panelHeader">
        <span>Quote Status</span>
      </div>
      <div class="panelBody">
        <table class="layoutTable">
          <tr>
            <td class="rightAligned labelColumn"><span>Quote Status:</span></td>
            <td class="dataColumn"><span>{{ quote.statusDescription }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>SFR Status:</span></td>
            <td class="dataColumn"><span>{{ quote.sfrStatus }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>FPA Status:</span></td>
            <td class="dataColumn"><span>{{ quote.fpaStatus }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn"><span>Approval Status:</span></td>
            <td class="dataColumn"><span>{{ approvalStatusDisplay() }}</span></td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn">
              <label for="frozenInput">Frozen:</label>
            </td>
            <td class="dataColumn">
              @if (userHasRole('IECCustomerService') || userHasRole('IECIT') || userHasRole('IECApplicationEngineer')) {
                <input
                  name="frozenInput" id="frozenInput" class="checkboxInput" type="checkbox"
                  [(ngModel)]="quote.frozen"/>
              }
              @if (!userHasRole('IECCustomerService') && !userHasRole('IECIT') && !userHasRole('IECApplicationEngineer')) {
                <span
                  >{{
                  quote.frozen
                  ? 'Yes' : 'No'
                }}</span>
              }
            </td>
          </tr>
          <tr>
            <td class="rightAligned labelColumn">
              <label for="priceProtectedInput">Price protected:</label>
            </td>
            <td class="dataColumn">
              @if (userHasRole('IECIT')) {
                <input name="priceProtectedInput" id="priceProtectedInput"
                  class="checkboxInput" type="checkbox" [(ngModel)]="quote.priceProtected"/>
              }
              @if (!userHasRole('IECIT')) {
                <span>{{ quote.priceProtected ? 'Yes' : 'No' }}</span>
              }
            </td>
          </tr>
          @if (showComplexityCategory()) {
            <tr>
              <td class="rightAligned labelColumn"><span>Estimated Eng. Effort:</span></td>
              <td class="dataColumn">
                <span class="dataLabel">{{ getComplexityCategory() }}</span>
                <mat-icon color="primary" (click)="showComplexityInformationDialog()"
                  class="size-16 infoIcon">info
                </mat-icon>
              </td>
            </tr>
          }
          @if (showComplexityCategory()) {
            <tr>
              <td class="rightAligned labelColumn">Estimated Lead Time:</td>
              <td class="dataColumn">{{ getComplexityLeadTime() }}</td>
            </tr>
          }
        </table>
      </div>
    </div>
  </div>
  @if (quote && !isNew()) {
    <div class="lineToolbar">
      <span class="linesLabel">
        <h3>Quote Lines</h3>
      </span>
      <span class="spacer">
      </span>
      <span>
        @if (showRiserChartButton()) {
          <button class="toolbarButton" matButton="text"
            [disabled]="quote.frozen" (click)="openRiserChartDialog()">
            <span>
              <mat-icon class="size-16">table_chart</mat-icon>
              <span class="buttonLabel">Riser Chart</span>
            </span>
          </button>
        }
        @if (quote.updateAllowed) {
          <button matButton="text" [ngClass]="{'skyportTaggingError': taggingRoomMissing()}"
            [disabled]="isBusy() || quote.frozen" (click)="openTaggingDialog()">
            <span>
              <mat-icon class="size-16">local_offer</mat-icon>
              <span class="buttonLabel">Tagging</span>
            </span>
          </button>
        }
        @if (userHasRole('IECIT') || userHasRole('IECCustomerService')) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()"
            (click)="openLeadTimeDialog()">
            <span>
              <mat-icon class="size-16">today</mat-icon>
              <span class="buttonLabel">Lead Times</span>
            </span>
          </button>
        }
        <button class="toolbarButton" matButton="text" [disabled]="isBusy() || getSelectedQuoteLineCount() !== 1" (click)="showLineSummary()">
          <span>
            <mat-icon class="size-16">visibility</mat-icon>
            <span class="buttonLabel">Summary</span>
          </span>
        </button>
        @if (quote.updateAllowed) {
          <button class="toolbarButton" matButton="text"
            [disabled]="isBusy() || getSelectedQuoteLineCount() === 0 || isSureFlowUnitSelected()"
            (click)="deleteSelectedLines()">
            <span>
              <mat-icon class="size-16">delete</mat-icon>
              <span class="buttonLabel">Delete</span>
            </span>
          </button>
        }
        <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="openSureFlowLoopSimulator()">
          <span>
            <mat-icon class="size-16">sim_card</mat-icon>
            <span class="buttonLabel">SureFlow® Loops</span>
          </span>
        </button>
        <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="openConfigurator()">
          <span>
            <mat-icon class="size-16">build</mat-icon>
            <span class="buttonLabel">Configurator</span>
          </span>
        </button>
        @if (isBypassUser()) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy() || !canAddLines()" (click)="importQuoteLines()">
            <span>
              <mat-icon class="size-16">cloud_upload</mat-icon>
              <span class="buttonLabel">Import Quote Lines</span>
            </span>
          </button>
        }
        @if (canAddLines()) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="addParts()">
            <span>
              <mat-icon class="size-16">add</mat-icon>
              <span class="buttonLabel">Parts</span>
            </span>
          </button>
        }
        <button class="toolbarButton" matButton="text" [disabled]="!canCopyLines()" (click)="copyLines()">
          <span>
            <mat-icon class="size-16">filter_none</mat-icon>
            <span class="buttonLabel">Copy To</span>
          </span>
        </button>
        @if (canAddLines()) {
          <button class="toolbarButton" matButton="text" [disabled]="isBusy()" (click)="addRisers()">
            <span>
              <mat-icon class="size-16">equalizer</mat-icon>
              <span class="buttonLabel">Risers</span>
            </span>
          </button>
        }
      </span>
    </div>
  }
  @if (quote && !isNew()) {
    <div>
      <table class="reportTable fullTableWidth">
        <thead>
          <tr>
            <td class="tableCell headerCell centeredCell">Line</td>
            <td class="tableCell headerCell centeredCell">Product</td>
            <td class="tableCell headerCell centeredCell">Description</td>
            <td class="tableCell headerCell centeredCell">Quantity</td>
            <td class="tableCell headerCell centeredCell">Best Lead Time</td>
            <td class="tableCell headerCell centeredCell">Unit List</td>
            <td class="tableCell headerCell centeredCell">Multiplier</td>
            <td class="tableCell headerCell centeredCell">Final Unit Price</td>
            <td class="tableCell headerCell centeredCell">Final Ext Price</td>
            <td class="tableCell headerCell centeredCell">Customer Item #</td>
            <td class="tableCell headerCell centeredCell">Tags</td>
          </tr>
        </thead>
        @if (quote.lines && quote.lines.length > 0) {
          @for (line of quote.lines; track line) {
            <tr [class.selectedRow]="isLineSelected(line)"
              [class.incompleteRow]="line.configured && !line.configurationComplete"
              [class.serialNumberMissingRow]="line.serialNumberRequired && (line.quantity > 1 || !line.serialNumber)"
              class="selectableRow"
              (click)="selectQuoteLineRow($event, line)">
              <td class="tableCell">{{ line.lineId }}</td>
              <td class="tableCell">{{ line.product }}</td>
              <td class="tableCell">{{ line.description }}</td>
              <td class="tableCell centeredCell">{{ line.quantity }}</td>
              <td class="tableCell centeredCell">{{ line.bestLeadTime }}</td>
              <td class="tableCell rightAligned">{{ line.unitList | currency:'USD' }}</td>
              <td class="tableCell centeredCell">{{ line.multiplier | number:'1.4-7' }}</td>
              <td class="tableCell rightAligned">{{ line.finalUnitPrice | currency:'USD' }}</td>
              <td class="tableCell rightAligned">{{ line.finalExtendedPrice | currency:'USD' }}</td>
              <td class="tableCell">{{ line.customerItemNumber }}</td>
              <td class="tableCell">
                @if (line.tags && line.tags.length > 0) {
                  <span>{{
                    line.tags.substring(0, 20) +
                    (line.tags.length > 20 ? '...' : '')
                    }}
                  </span>
                }
              </td>
            </tr>
          }
        }
        @if (!quote.lines || quote.lines.length === 0) {
          <tr>
            <td colspan="11">No lines found</td>
          </tr>
        }
      </table>
    </div>
  }
</div>
}
</form>
